import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row} from "react-bootstrap";
import { PencilIcon, SearchIcon } from '@primer/octicons-react'
import LocPickerDialog from './LocPickerDialog';
import LiftPickerDialog from './LiftPickerDialog'
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';
import { formatDate } from '../utils/timeUtils';


const CCTVCamAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [cctvCamAttrs, setCCTVCamAttrs] = useState({
    code: '',
    description: '',
    displayName: '',
    apiCode: '',
    assetCode: '',
    locationId: '',
    location: '',
    coverageLocId: '',
    coverageLoc: '',
    spaceType: '',
    spaceSubType: '',
    liftId: '',
    liftCode: '',
    custBool1: false,
    status: ''
  });

  const [currentCCTVCamAttrs, setCurrentCCTVCamAttrs] = useState({});

  //const [sensitive, setSensitive] = useState(false);

  const statusOptions = [
    { key: "ACTIVE",    value: "ACTIVE" },
    { key: "DISABLED", value: "DISABLED" }
  ];

  const spaceTypeOptions = [
    { key: "LOCATION", value: "LOCATION" },
    { key: "LIFT",     value: "LIFT" }
  ];

  const spaceSubTypeOptions = [
    { key: "CAB",       value: "CAB" },
    { key: "LOWER_CAB", value: "LOWER_CAB" },
    { key: "UPPER_CAB", value: "UPPER_CAB" }
  ];


  // UI Functions

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);
  const [errMsg,   setErrMsg]   = useState('');


  // UI Functions

  // Location picker dialog stuff

  const [locPickerMode,       setLocPickerMode]       = useState('');
  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);


  const handleLocPickerLoc = (e) => {
    setLocPickerMode('LOC');
    setShowLocPickerDialog(true);
  }

  const handleLocPickerCoverLoc = (e) => {
    setLocPickerMode('COVER_LOC');
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {

    // Deep copy
    let newAttr = JSON.parse (JSON.stringify(cctvCamAttrs));

    if (locPickerMode === 'LOC') {
      newAttr.locationId = location.id;
      newAttr.location   = location.code;
    } else if (locPickerMode === 'COVER_LOC') {
      newAttr.coverageLocId = location.id;
      newAttr.coverageLoc   = location.code;
    }

    setCCTVCamAttrs(newAttr);

    setShowLocPickerDialog(false);
  }


  // Lift picker dialog stuff

  const [showLiftPickerDialog, setShowLiftPickerDialog] = useState(false);

  const handleLiftPicker = (e) => {
    setShowLiftPickerDialog(true);
  }

  function handleLiftPickerClose() {
    setShowLiftPickerDialog(false);
  }

  function handleLiftSelect(lift) {

    // Deep copy
    let newAttr = JSON.parse (JSON.stringify(cctvCamAttrs));

    newAttr.liftId   = lift.id;
    newAttr.liftCode = lift.code;

    setCCTVCamAttrs(newAttr);

    setShowLiftPickerDialog(false);
  }


  // General stuff

  // Initialize state
  useEffect(() => {
    if (props) {
      setCCTVCamAttrs(props.objDetails);
      setCurrentCCTVCamAttrs(props.objDetails);
    }
  }, [props]);


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, [e.target.name]: e.target.value })
  }

  const onSensitiveChange = (event) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, isSensitive: event.target.checked })
  };

  const onStatusSelect = (key, event) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, status: key })
  };

  const onSpaceTypeSelect = (key, event) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, spaceType: key })
  };

  const onSpaceSubTypeSelect = (key, event) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, spaceSubType: key })
  };

  const onVisibleToOwnerChange = (event) => {
    setCCTVCamAttrs({ ...cctvCamAttrs, custBool1: event.target.checked })
  };

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setCCTVCamAttrs(currentCCTVCamAttrs);

    setErrMsg("");
    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!cctvCamAttrs.code || cctvCamAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_CCTV_cam_code"));
    } else {
      validateOtherFields();
    }

    return;
  }

  function validateOtherFields() {
    // Validate form inputs
    if (cctvCamAttrs.code.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 30);
      return;
    } else if (!cctvCamAttrs.description || cctvCamAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (cctvCamAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!cctvCamAttrs.displayName || cctvCamAttrs.displayName.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_display_name"));
      return;
    } else if (cctvCamAttrs.displayName.length > 30) {
      setErrMsg(t("I18N_ERR_Max_len_disp_name") + 30);
      return;
    } else if (!cctvCamAttrs.apiCode || cctvCamAttrs.apiCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_API_code"));
      return;
    } else if (cctvCamAttrs.apiCode.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_api_code") + 200);
      return;
    } else if (!cctvCamAttrs.assetCode || cctvCamAttrs.assetCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_asset_id"));
      return;
    } else if (cctvCamAttrs.assetCode.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_asset_code") + 50);
      return;
    } else if (!cctvCamAttrs.status || cctvCamAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;
    } else if (!cctvCamAttrs.spaceType || cctvCamAttrs.spaceType.length === 0) {
      setErrMsg(t("I18N_ERR_Need_space_type"));
      return;
    }

    if (cctvCamAttrs.spaceType === 'LOCATION') {
      if (!cctvCamAttrs.locationId || cctvCamAttrs.locationId.length === 0) {
        setErrMsg(t("I18N_ERR_Need_location_code"));
        return;
      } else if (!cctvCamAttrs.coverageLocId || cctvCamAttrs.coverageLocId.length === 0) {
        setErrMsg(t("I18N_ERR_Need_cov_loc_code"));
        return;
      }
    } else if (cctvCamAttrs.spaceType === 'LIFT') {
      if (!cctvCamAttrs.spaceSubType || cctvCamAttrs.spaceSubType.length === 0) {
        setErrMsg(t("I18N_ERR_Need_space_sub_type"));
        return;
      } else if (!cctvCamAttrs.liftCode || cctvCamAttrs.liftCode.length === 0) {
        setErrMsg(t("I18N_ERR_Need_lift_code"));
        return;
      }
    }

    updateCCTVCam();
  }

  const updateCCTVCam = () => {

    const reqBody = cctvCamAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("cctv-cams/" + cctvCamAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          refreshCCTVCamAttrs(cctvCamAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const refreshCCTVCamAttrs = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("cctv-cams-admin/" + id);

        resolve(res.data);

        if (res.status === 200) {

          setCCTVCamAttrs(res.data[0]);
          setCurrentCCTVCamAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_CCTVCam_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_CCTVCam_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Code")}: *</Col>
                  <Col md={3}>{t("I18N_Description")}: *</Col>
                  <Col md={3}>{t("I18N_Display_name")}: *</Col>
                  <Col md={3}>{t("I18N_API_code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code" value={cctvCamAttrs.code}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                              value={cctvCamAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="displayName" value={cctvCamAttrs.displayName}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="apiCode" value={cctvCamAttrs.apiCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col md={3}>{t("I18N_Asset_code")}: *</Col>
                  <Col md={3}>{t("I18N_Sensitive")}:</Col>
                  <Col md={3}>{t("I18N_Status")}: *</Col>
                  <Col md={3}></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="assetCode" value={cctvCamAttrs.assetCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <Form.Check
                      type="switch"
                      id="mfa-email"
                      checked={cctvCamAttrs.isSensitive}
                      onChange={onSensitiveChange}
                    />
                  </Col>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ !cctvCamAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_ST_" + cctvCamAttrs.status) }
                      onSelect={onStatusSelect}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_ST_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col md={3}></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col md={3}>{t("I18N_Space_type")}: *</Col>
                  { cctvCamAttrs.spaceType === 'LOCATION' ?
                    <>
                      <Col md={3}>{t("I18N_Location_code")}: *</Col>
                      <Col md={3}>{t("I18N_Coverage_loc_code")}: </Col>
                    </>
                  : cctvCamAttrs.spaceType === 'LIFT' ?
                    <>
                      <Col md={3}>{t("I18N_Space_subtype")}: *</Col>
                      <Col md={3}>{t("I18N_Lift_code")}: *</Col>
                    </>
                  : null
                  }
                  <Col md={3}></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={ !cctvCamAttrs.spaceType ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_CCTV_SP_TYPE_" + cctvCamAttrs.spaceType) }
                      onSelect={onSpaceTypeSelect}>
                      {spaceTypeOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_CCTV_SP_TYPE_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>

                  { cctvCamAttrs.spaceType === 'LOCATION' ?
                    <>
                      <Col md={3}>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="location"
                          value={cctvCamAttrs.location ? cctvCamAttrs.location : ""}
                          onChange={(e) => onAttrsInputChange(e)} />
                        <span onClick={handleLocPickerLoc} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                      </Col>
                      <Col md={3}>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="coverageLoc"
                          value={cctvCamAttrs.coverageLoc ? cctvCamAttrs.coverageLoc : ""}
                          onChange={(e) => onAttrsInputChange(e)} />
                        <span onClick={handleLocPickerCoverLoc} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                      </Col>
                    </>
                  : cctvCamAttrs.spaceType === 'LIFT' ?
                    <>
                      <Col md={3}>
                        <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                          title={ !cctvCamAttrs.spaceSubType ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_LIFT_SUB_SP_TYPE_" + cctvCamAttrs.spaceSubType) }
                          onSelect={onSpaceSubTypeSelect}>
                          {spaceSubTypeOptions.map((item, index) => {
                            return (
                              <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                                {t("I18N_LIFT_SUB_SP_TYPE_" + item.value)}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Col>
                      <Col md={3}>
                        <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="liftCode"
                          value={cctvCamAttrs.liftCode ? cctvCamAttrs.liftCode : ""}
                          onChange={(e) => onAttrsInputChange(e)} />
                        <span onClick={handleLiftPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                      </Col>
                    </>
                  : null
                  }
                  <Col md={3}></Col>
                </Row>

                { configInfo.uiConfig.visibleFields.CCTVCAM_VisbleToOwner ?
                  <>
                    <hr className="solid" style={{ marginTop: '15px' }}></hr>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '-5px' }}>
                      <Col>{t("I18N_Visible_to_owner")}:</Col>
                      <Col></Col>
                      <Col></Col>
                      <Col></Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col>
                        <Form.Check
                          type="switch"
                          id="mfa-email"
                          checked={cctvCamAttrs.custBool1}
                          onChange={onVisibleToOwnerChange}
                        />
                      </Col>
                      <Col></Col>
                      <Col></Col>
                      <Col></Col>
                    </Row>
                    <hr className="solid" style={{ marginTop: '15px' }}></hr>
                 </>
                : null
                }

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Code")}:</Col>
                <Col md={3}>{t("I18N_Description")}:</Col>
                <Col md={3}>{t("I18N_Display_name")}:</Col>
                <Col md={3}>{t("I18N_API_code")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{cctvCamAttrs.code}</Col>
                <Col md={3}>{cctvCamAttrs.description}</Col>
                <Col md={3}>{cctvCamAttrs.displayName}</Col>
                <Col md={3}>{cctvCamAttrs.apiCode}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col md={3}>{t("I18N_Asset_code")}:</Col>
                <Col md={3}>{t("I18N_Sensitive")}:</Col>
                <Col md={3}>{t("I18N_Status")}:</Col>
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{cctvCamAttrs.assetCode}</Col>
                <Col md={3}>{cctvCamAttrs.isSensitive ? t("I18N_Yes") : t("I18N_No")}</Col>
                <Col md={3}>{t("I18N_ST_" + cctvCamAttrs.status)}</Col>
                <Col md={3}></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col md={3}>{t("I18N_Space_type")}:</Col>
                { cctvCamAttrs.spaceType === 'LOCATION' ?
                  <>
                    <Col md={3}>{t("I18N_Location_code")}: </Col>
                    <Col md={3}>{t("I18N_Coverage_loc_code")}: </Col>
                  </>
                : cctvCamAttrs.spaceType === 'LIFT' ?
                  <>
                    <Col md={3}>{t("I18N_Space_subtype")}: </Col>
                    <Col md={3}>{t("I18N_Lift_code")}: </Col>
                  </>
                : null
                }
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{t("I18N_CCTV_SP_TYPE_" + cctvCamAttrs.spaceType)}</Col>
                { cctvCamAttrs.spaceType === 'LOCATION' ?
                    <>
                      <Col md={3}>{cctvCamAttrs.location}</Col>
                      <Col md={3}>{cctvCamAttrs.coverageLoc}</Col>
                    </>
                  : cctvCamAttrs.spaceType === 'LIFT' ?
                    <>
                      <Col md={3}>{t("I18N_LIFT_SUB_SP_TYPE_" + cctvCamAttrs.spaceSubType)}</Col>
                      <Col md={3}>{cctvCamAttrs.liftCode}</Col>
                    </>
                  : null
                }
                <Col md={3}></Col>
              </Row>

              { configInfo.uiConfig.visibleFields.CCTVCAM_VisbleToOwner ?
                <>
                  <hr className="solid" style={{ marginTop: '15px' }}></hr>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '-5px' }}>
                    <Col>{t("I18N_Visible_to_owner")}:</Col>
                    <Col></Col>
                    <Col></Col>
                    <Col></Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>{cctvCamAttrs.custBool1 ? t("I18N_Yes") : t("I18N_No")}</Col>
                    <Col></Col>
                    <Col></Col>
                    <Col></Col>
                  </Row>
                  <hr className="solid" style={{ marginTop: '15px' }}></hr>
               </>
              : null
              }

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{cctvCamAttrs.creatorUsername}</Col>
                <Col>{formatDate(cctvCamAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{cctvCamAttrs.updaterUsername}</Col>
                <Col>{formatDate(cctvCamAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
          </Form.Group>
        </div>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

        <LiftPickerDialog
          show={showLiftPickerDialog}
          handleObjSelect={handleLiftSelect}
          onClose={handleLiftPickerClose}
        />

{/*
        <Modal show={showLiftPickerDialog} onHide={handleLiftSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Lift_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <form onSubmit={handleLiftSearch}>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Lift_code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="searchTerm"
                           placeholder={t("custom:I18N_Eg_search_lift")} onChange={(e) => onLiftSearchInputChange(e)} />
                  </Col>
                  <Col>
                    <span onClick={handleLiftSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Lift_code")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(liftList && liftList.length > 0) ? liftList.map(renderLift) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_LiftSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleLiftSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>

              </form>
            </div>
          </Modal.Body>
        </Modal>
*/}

      </Card>
    </>
  );
}

export default CCTVCamAdminDetailsView;
